<!-- INPUT:
Date = from to
Overall - cond 0
Tenantwise cond-1 and tenant name
SCORECARD:
Total Users -
Expired users -
Dormant users -
Active users -
(Score card)Score card Dormant no of accounts
(Score card)Score card Active no of accounts
(Score card)Score card Overall no of accounts
(Pivot view)    Drilldown of assessments,acc name, technology ,month,created date ,users  and its count with autotags
(Chart) No of new assessments by tenant - 50 total count -34L ,how many Auto tags 5
    Drilldown of assessments,acc name, technology ,month,created date ,users  and its count with autotags
(bar view ) Month wise new assessment( jan 15) and new users( jan 20) -->
<template>
  <form class="position-relative">
    <section class="wrapper container-fluid">
      <form class="row g-3">
        <div class="col-6 col-lg-8 mb-2">
          <label for="fromDate" class="form-label">Date Range</label>
          <Datepicker :dark="$store.state.TClrs != 'lightTheme'" v-model="qDates" format="dd-MMM-yyyy" range
            :enableTimePicker="false" />
        </div>
        <div class="col-6 col-lg-4 mb-2">
          <label for="tenant" class="form-label">Select Tenant</label>
          <VueMultiselect class="mymultiselect  hide-on-presentation " id="tenant" openDirection="bottom" v-model="tenant" :options="allTenants"
            :multiple="false" :allow-empty="false" selectLabel="" deselect-label="can't Deselect"
            :close-on-select="true" />
        </div>
      </form>
      <div id="accountSection" class="sectionHolder">
        <div class="row">
          <div class="col-4 col-lg-2">
            <div class="card-quality myBoxShadow spl">
              <div class="boxC">
                <div class="inner">
                  <h3 class="text-center"> {{ account.total }} </h3>
                </div>
                <div class="icon">
                  <font-awesome-icon icon="fa-solid fa-file-shield" />
                </div>
                <div class="card-quality-footer text-ellipsis">Total Accounts</div>
              </div>
            </div>
          </div>
          <div class="col-4 col-lg-2">
            <div class="card-quality myBoxShadow spl">
              <div class="boxC">
                <div class="inner">
                  <h3 class="text-center"> {{ account.active }} </h3>
                </div>
                <div class="icon">
                  <font-awesome-icon icon="fa-solid fa-file-circle-check" />
                </div>
                <div class="card-quality-footer text-ellipsis">Active Account(s)</div>
              </div>
            </div>
          </div>
          <div class="col-4 col-lg-2">
            <div class="card-quality myBoxShadow spl">
              <div class="boxC">
                <div class="inner">
                  <h3 class="text-center"> {{ account.dormant }} </h3>
                </div>
                <div class="icon">
                  <font-awesome-icon icon="fa-solid fa-file-circle-xmark" />
                </div>
                <div class="card-quality-footer text-ellipsis">Dormant Account(s)</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="cardR">
              <div class="boxR">
                <div class="content-panel1">
                  <h2 class="chartTitle hide-on-presentation themeclr2">New Account(s) by Tenant</h2>
                  <v-chart :option="options" :autoresize="true" style="width: 100%" />
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="cardR">
              <div class="boxR">
                <div class="content-panel1">
                  <h2 class="chartTitle hide-on-presentation themeclr2">Updates Account(s) by Tenant</h2>
                  <v-chart :option="options" :autoresize="true" style="width: 100%" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="userSection" class="sectionHolder">
        <div class="row">
          <div class="col-4 col-lg-2">
            <div class="card-quality myBoxShadow spl">
              <div class="boxC">
                <div class="inner">
                  <h3 class="text-center"> {{ users.total }} </h3>
                </div>
                <div class="icon">
                  <font-awesome-icon :icon="['fas', 'users']" />
                </div>
                <div class="card-quality-footer text-ellipsis">Total users</div>
              </div>
            </div>
          </div>
          <div class="col-4 col-lg-2">
            <div class="card-quality myBoxShadow spl">
              <div class="boxC">
                <div class="inner">
                  <h3 class="text-center"> {{ users.active }} </h3>
                </div>
                <div class="icon">
                  <font-awesome-icon :icon="['fas', 'user-check']" />
                </div>
                <div class="card-quality-footer text-ellipsis">Active users</div>
              </div>
            </div>
          </div>
          <div class="col-4 col-lg-2">
            <div class="card-quality myBoxShadow spl">
              <div class="boxC">
                <div class="inner">
                  <h3 class="text-center"> {{ users.dormant }} </h3>
                </div>
                <div class="icon">
                  <font-awesome-icon :icon="['fas', 'user-tag']" />
                </div>
                <div class="card-quality-footer text-ellipsis">Dormant users</div>
              </div>
            </div>
          </div>
          <div class="col-4 col-lg-2">
            <div class="card-quality myBoxShadow spl">
              <div class="boxC">
                <div class="inner">
                  <h3 class="text-center"> {{ users.expired }} </h3>
                </div>
                <div class="icon">
                  <font-awesome-icon :icon="['fas', 'user-clock']" />
                </div>
                <div class="card-quality-footer text-ellipsis">Expired users</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="cardR">
              <div class="boxR">
                <div class="content-panel1">
                  <h2 class="chartTitle hide-on-presentation themeclr2">New Users by Tenant</h2>
                  <v-chart :option="optionsNewUsers" :autoresize="true" style="width: 100%" />
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="cardR">
              <div class="boxR">
                <div class="content-panel1">
                  <h2 class="chartTitle hide-on-presentation themeclr2">Active Users by Tenant</h2>
                  <v-chart :option="optionsActiveUsers" :autoresize="true" style="width: 100%" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="assessmentSection" class="sectionHolder">
        <div class="row">
          <div class="col-4 col-lg-2">
            <div class="card-quality myBoxShadow spl">
              <div class="boxC">
                <div class="inner">
                  <h3 class="text-center"> {{ assessment.total }} </h3>
                </div>
                <div class="icon">
                  <font-awesome-icon :icon="['fas', 'users']" />
                </div>
                <div class="card-quality-footer text-ellipsis">Total Assessment</div>
              </div>
            </div>
          </div>
          <div class="col-4 col-lg-2">
            <div class="card-quality myBoxShadow spl">
              <div class="boxC">
                <div class="inner">
                  <h3 class="text-center"> {{ assessment.new }} </h3>
                </div>
                <div class="icon">
                  <font-awesome-icon :icon="['fas', 'user-check']" />
                </div>
                <div class="card-quality-footer text-ellipsis">New Assessment</div>
              </div>
            </div>
          </div>
          <div class="col-4 col-lg-2">
            <div class="card-quality myBoxShadow spl">
              <div class="boxC">
                <div class="inner">
                  <h3 class="text-center"> {{ assessment.updated }} </h3>
                </div>
                <div class="icon">
                  <font-awesome-icon :icon="['fas', 'user-tag']" />
                </div>
                <div class="card-quality-footer text-ellipsis">Updated Assessment</div>
              </div>
            </div>
          </div>
          <div class="col-4 col-lg-2">
            <div class="card-quality myBoxShadow spl">
              <div class="boxC">
                <div class="inner">
                  <h3 class="text-center"> {{ assessment.dormant }} </h3>
                </div>
                <div class="icon">
                  <font-awesome-icon :icon="['fas', 'user-clock']" />
                </div>
                <div class="card-quality-footer text-ellipsis">Dormant Assessment</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="cardR">
              <div class="boxR">
                <div class="content-panel1">
                  <h2 class="chartTitle hide-on-presentation themeclr2">New Assessment</h2>
                  <v-chart :option="optionsNewUsers" :autoresize="true" style="width: 100%" />
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="cardR">
              <div class="boxR">
                <div class="content-panel1">
                  <h2 class="chartTitle hide-on-presentation themeclr2">Updated Assessment</h2>
                  <v-chart :option="optionsActiveUsers" :autoresize="true" style="width: 100%" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </form>
</template>
<script>
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import VChart from "vue-echarts";
export default {
  name: 'analyticsPage',
  props: {
  },
  components: {
    Datepicker,
    VChart
  },
  data() {
    return {
      users: {
        expired: 25,
        dormant: 27,
        active: 63,
        total: 115
      },
      account: {
        dormant: 25,
        active: 35,
        total: 60
      },
      assessment: {
        dormant: 25,
        updated: 25,
        new: 35,
        total: 60
      },
      qDates: [],
      allTenants: ["All", "Retail", "TTH", "Lifesciences", "Media", "Hitech", "Carrier", "Demo", "CTU", "Terex",
        "EM", "INS", "BFS", "CMT", "ACE", "MFG", "Others", "Energy", "EY", "Utilities"
      ],
      tenant: "All",
      options: {},
      optionsNewUsers: {},
      optionsActiveUsers: {}
    }
  },
  methods: {
    getCountDate(cond) {
      let senObj = {
        allTanent: cond,
        from: this.fromDate,
        to: this.toDate,
      }
      this.axios.post(this.uriApiUrl + 'UserSetting/choose_bu?', senObj,{
      headers: {
            'Content-Type': 'application/json'
          }})
        .then((response) => {
          if (response.status == 200) {
            if (response.data == "Error") {
              this.$notify({
                type: "error",
                text: "something went wrong! Please try again after sometime"
              })
            } else {
              // console.log("HI")
            }
          }
        }).catch((error) => {
          this.$notify({
            type: "error",
            text: "Error Occured during Tenant Registration ! Please try again."
          })
        })
    },
  },
  computed: {
  },
  mounted() {
    const colors = ['#5470C6', '#91CC75', '#EE6666'];
    this.options = {
      color: colors,
      tooltip: {
        confine: true,
        trigger: 'axis',
      },
      grid: {
        right: '20%'
      },
      legend: {
        show: true
      },
      xAxis: [{
        type: 'category',
        axisTick: {
          alignWithLabel: true
        },
        // prettier-ignore
        data: ["Retail", "TTH", "Lifesciences", "Media", "Hitech", "Carrier", "Demo", "CTU",
          "Terex", "EM", "INS", "BFS", "CMT", "ACE", "MFG", "Others", "Energy", "EY", "Utilities"
        ]
      }],
      yAxis: [{
        type: 'value',
        name: 'Accounts',
        position: 'left',
        alignTicks: true,
        axisLine: {
          show: true,
        },
      },
      {
        type: 'value',
        name: '# Records',
        position: 'right',
        alignTicks: true,
        axisLine: {
          show: true,
        },
        axisLabel: {
          formatter: '{value}k'
        }
      }
      ],
      series: [{
        name: 'Accounts',
        type: 'bar',
        data: [
          2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3, 135.6,
          162.2, 32.6, 20.0, 6.4, 3.3, 32.6
        ]
      },
      {
        name: '# Records',
        type: 'line',
        yAxisIndex: 1,
        data: [2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2, 10.2, 20.3,
          23.4, 23.0, 16.5, 12.0, 6.2
        ]
      }
      ]
    };
    this.optionsNewUsers = {
      color: colors,
      tooltip: {
        confine: true,
        trigger: 'axis',
      },
      grid: {
        right: '20%'
      },
      legend: {
        show: true
      },
      xAxis: [{
        type: 'category',
        axisTick: {
          alignWithLabel: true
        },
        // prettier-ignore
        data: ["Retail", "TTH", "Lifesciences", "Media", "Hitech", "Carrier", "Demo", "CTU",
          "Terex", "EM", "INS", "BFS", "CMT", "ACE", "MFG", "Others", "Energy", "EY", "Utilities"
        ]
      }],
      yAxis: [{
        type: 'value',
        name: 'Users',
        position: 'left',
        alignTicks: true,
        axisLine: {
          show: true,
        },
      }
      ],
      series: [{
        name: 'New Users',
        type: 'bar',
        data: [
          2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3, 135.6,
          162.2, 32.6, 20.0, 6.4, 3.3, 32.6
        ]
      },
      ]
    };
    this.optionsActiveUsers = {
      color: colors,
      tooltip: {
        confine: true,
        trigger: 'axis',
      },
      grid: {
        right: '20%'
      },
      legend: {
        show: true
      },
      xAxis: [{
        type: 'category',
        axisTick: {
          alignWithLabel: true
        },
        // prettier-ignore
        data: ["Retail", "TTH", "Lifesciences", "Media", "Hitech", "Carrier", "Demo", "CTU",
          "Terex", "EM", "INS", "BFS", "CMT", "ACE", "MFG", "Others", "Energy", "EY", "Utilities"
        ]
      }],
      yAxis: [{
        type: 'value',
        name: 'Users',
        position: 'left',
        alignTicks: true,
        axisLine: {
          show: true,
        },
      }
      ],
      series: [{
        name: 'Active Users',
        type: 'bar',
        data: [
          2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3, 135.6,
          162.2, 32.6, 20.0, 6.4, 3.3, 32.6
        ]
      },
      ]
    };
  },
}
</script>
<style scoped>
input[type="date"]::-webkit-calendar-picker-indicator {
  filter: invert(0.5);
}

form .form-label {
  font-size: 14px;
}

.mymultiselect .multiselect__select {
  padding: 0;
}

.content-panel1 {
  height: 500px;
}

.sectionHolder {
  border: 1px solid #777;
  padding: 10px;
  margin-bottom: 40px;
  border-radius: 10px;
}</style>